export enum TextFieldType {
    TEXT = "text",
    NUMBER = "number",
    EMAIL = "email",
    SEARCH = "search",
    PASSWORD = "password"
}
